var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 file-control-container",class:_vm.bgClass},[_c('div',{staticClass:"file-control d-flex align-items-center justify-content-center"},[_c('span',{staticClass:"file-control__text",class:_vm.textClass},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"file-control__icon",class:_vm.iconClass,attrs:{"icon":_vm.icon}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4837d310","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-elements/file-control.vue
// module id = 128
// module chunks = 0